export default "__VITE_ASSET__D0d_NQXj__"